module.exports = __webpack_public_path__ + "static/media/icon-freeplay.1b8b17c1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/RewardIcon/icon-freeplay.svg
// module id = 1435
// module chunks = 1